import { CHECKBOX } from './constants';
import { ALL, ORDERS, INTELLI_FORMS } from '../../../utils/constants';

// Status options for PaymentForms - ALL tab
const PAYMENT_FORMS_ALL_STATUS_ITEMS = [
  { key: 'CREATED', text: 'Active', value: 'CREATED' },
  { key: 'EXPIRED', text: 'Expired', value: 'EXPIRED' },
  { key: 'CANCELLED', text: 'Cancelled', value: 'CANCELLED' },
];

// Status options for PaymentForms - ORDERS tab
const PAYMENT_FORMS_ORDERS_STATUS_ITEMS = [
  { key: 'SUCCESS', text: 'Success', value: 'SUCCESS' },
  { key: 'PENDING', text: 'Pending', value: 'PENDING' },
  { key: 'FAILED', text: 'Failed', value: 'FAILED' },
  { key: 'USER_DROPPED', text: 'User Dropped', value: 'USER_DROPPED' },
  { key: 'INCOMPLETE', text: 'Incomplete', value: 'INCOMPLETE' },
];

export default {
  [ALL]: {
    TABLE_COLUMNS: [
      {
        key: 'txTime',
        displayName: 'Created At',
        width: 0.4,
      },
      {
        key: 'formShortCode',
        displayName: 'Form Code',
        width: 0.3,
      },
      {
        key: 'CFOrderId',
        displayName: 'CF Form ID',
        width: 0.3,
      },
      {
        key: 'orderAmount',
        displayName: 'Amount',
        align: 'right',
        width: 0.1,
      },
      {
        key: 'linkUrl',
        displayName: 'URL',
        width: 1,
      },
      {
        key: 'txStatus',
        displayName: 'Status',
        width: 0.5,
      },
      {
        key: 'paymentFormCTA',
        displayName: '',
        width: 0.01,
      },
    ],
    FILTER_ITEMS: {
      status: {
        displayText: 'Status',
        type: CHECKBOX,
        items: PAYMENT_FORMS_ALL_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'referenceId',
        text: 'Form ID',
        value: 'referenceId',
        placeholder: 'Enter Form ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'id',
        text: 'CF Form ID',
        value: 'id',
        placeholder: 'Enter CF Form ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'form_url',
        text: 'Form URL',
        value: 'form_url',
        placeholder: 'Enter Form URL',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
    ],
  },
  [ORDERS]: {
    TABLE_COLUMNS: [
      {
        key: 'txTime',
        displayName: 'Date & Time',
        width: 0.15,
      },
      {
        key: 'orderID',
        displayName: 'Order ID',
        width: 0.15,
      },
      {
        key: 'txnId',
        displayName: 'Transaction ID',
        width: 0.2,
      },
      {
        key: 'paymentRequestId',
        displayName: 'CF Form ID',
        width: 0.15,
      },
      {
        key: 'referenceId',
        displayName: 'Form ID',
        width: 0.15,
      },
      {
        key: 'orderAmount',
        displayName: 'Amount',
        align: 'right',
        width: 0.1,
      },
      {
        key: 'customerPhone',
        displayName: 'Phone No.',
        width: 0.1,
      },
      {
        key: 'customerEmail',
        displayName: 'Email ID',
        width: 0.15,
      },
      {
        key: 'txStatus',
        displayName: 'Status',
        width: 0.1,
      },
    ],
    FILTER_ITEMS: {
      status: {
        displayText: 'Status',
        type: CHECKBOX,
        items: PAYMENT_FORMS_ORDERS_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'customerPhone',
        text: 'Phone No.',
        value: 'customerPhone',
        placeholder: 'Enter Phone No.',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'customerEmail',
        text: 'Email ID',
        value: 'customerEmail',
        placeholder: 'Enter Email ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter Order ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'paymentRequestId',
        text: 'CF Form ID',
        value: 'paymentRequestId',
        placeholder: 'Enter CF Form ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'paymentRequestReferenceId',
        text: 'Form ID',
        value: 'paymentRequestReferenceId',
        placeholder: 'Enter Form ID',
        inputPattern: '^[\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
    ],
  },
  [INTELLI_FORMS]: {
    TABLE_COLUMNS: [
      {
        key: 'txTime',
        displayName: 'Created At',
        width: 0.2,
      },
      {
        key: 'formShortCode',
        displayName: 'Form Code',
        width: 0.2,
      },
      {
        key: 'CFOrderId',
        displayName: 'CF Form ID',
        width: 0.2,
      },
      {
        key: 'linkUrl',
        displayName: 'URL',
        width: 0.2,
      },
      {
        key: 'txStatus',
        displayName: 'Status',
        width: 0.1,
      },
      {
        key: 'action',
        displayName: 'Action',
        width: 0.1,
      },
    ],
  },
};
